import { Link, Message } from "basis";

const regionToFaqUrlMap = {
  AU: "https://latitudefs.zendesk.com/hc/en-au/sections/360002045037-Direct-Debits-Payment-Questions",
  NZ: "https://gemfinance.zendesk.com/hc/en-nz/sections/360002848237-Payment-Questions",
};

interface Props {
  region: "AU" | "NZ";
}

export const InEligibleAccountMessage = ({ region }: Props) => {
  const url = regionToFaqUrlMap[region];
  return (
    <Message
      severity="info-or-minor"
      bg="secondary.lightBlue.t25"
      role="status"
    >
      Debit card payment is unavailable for this account.
      <br />
      {
        "Please select another payment type. More information can be found in our "
      }
      <Link href={url} newTab>
        FAQs.
      </Link>
    </Message>
  );
};
